module.exports = __webpack_public_path__ + "assets/rangings.42fbcd99.svg";